var map = {
	"./arrow-down.svg": 4746,
	"./arrow-left.svg": 1833,
	"./barcode.svg": 8820,
	"./battery.svg": 5573,
	"./card.svg": 4479,
	"./cart.svg": 9163,
	"./cash.svg": 4468,
	"./chat.svg": 5166,
	"./check.svg": 706,
	"./checked.svg": 2173,
	"./close.svg": 420,
	"./credit-card.svg": 9721,
	"./id.svg": 9341,
	"./lock_action.svg": 9289,
	"./lock_elo.svg": 3832,
	"./lock_muller.svg": 7361,
	"./minus.svg": 4475,
	"./phone.svg": 9193,
	"./plus.svg": 3189,
	"./ruler.svg": 251,
	"./search.svg": 9262,
	"./terminal.svg": 9780,
	"./tick.svg": 2058,
	"./trash.svg": 967,
	"./wifi.svg": 9617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;